const ROOT = process.env.REACT_APP_BACKEND_INTERCONEXION + "/api";

const rutasInterconexion = {
  delegado: ROOT + "/delegado",
  tipodecambio: ROOT + "/tipodecambio"
};

export default rutasInterconexion;
